<gbc-tile [title]="title">
  <nav>
    @for (tab of tabs; track tab) {
      <a (click)="selectTab(tab)" [class.active]="tab.active">{{tab.title}}</a>
    }
  </nav>
  <ng-content></ng-content>
</gbc-tile>
